exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contractors-example h1 {\n  background-color: purple\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/contractors/public/assets/css/contractors.css
// module id = 703
// module chunks = 0